import { ReactNode } from "react";
import ToggleIconButton from "../../../components/buttons/toggleIconButton";
import { useTheme } from "../../../context/useThemeContext";
import { hexToRGBA } from "../../../utility/hexToRGB";

export function TopButton(props: {
    icon: ReactNode;
    isActive?: boolean;
    isDisabled?: boolean;
    sizeX?: number;
    className?: string;
    disableHover?: boolean;
    alt?: string;
    onClick?: (e: React.MouseEvent) => void;
}) {
    const { theme } = useTheme();

    return (
        <ToggleIconButton
            alt={props.alt}
            size={{ x: props.sizeX ? props.sizeX : 26, y: 26 }}
            hoverBGInactive={props.disableHover ? "" : hexToRGBA(theme.accentColor, 0.2)}
            hoverIconInactive={props.disableHover ? "" : theme.fontColor[50]}
            icon={props.icon}
            onClick={props.onClick}
            className={"flex-grow-0 " + props.className}
            inactiveBGColor={props.isActive ? theme.headerColor : ""}
            style={{
                opacity: props.isDisabled ? 0.5 : 1,
                pointerEvents: props.isDisabled ? "none" : "unset",
            }} />
    );
}
